function log(message, level) {
    if (level === 'error') {
        console.error('SIC - ERROR - ' + message);
    } else if (level === 'warn') {
        console.warn('SIC - WARN - ' + message);
    } else {
        console.info('SIC - INFO - ' + message);
    }
}

exports.log = log;